// src/App.js
import React, { useEffect, useState } from "react";
import { Route, Routes, Navigate, useLocation, useNavigate } from "react-router-dom";
import Login from "./components/Login/Login";
import Home from "./components/Home/Home";
import Layout from "./components/Layout/Layout";
import Profesores from "./components/Profesores/Profesores"; // Importamos Profesores.js
import Estudiantes from "./components/Estudiantes/Estudiantes"; // Importamos Estudiantes.js
import EstudianteDetalles from "./components/Estudiantes/EstudianteDetalle"; // Importar EstudianteDetalles.js
import Asistencia from "./components/Asistencia/Asistencia"; // Importar Asistencia.js
import Reportes from "./components/Reportes/Reportes"; // Importamos Reportes.js
import EstudianteFaltas from "./components/Estudiantes/EstudianteFaltas"; // <-- NUEVO

// Componente para proteger rutas
const ProtectedRoute = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [user, setUser] = useState(() => {
    const storedUser = localStorage.getItem("user");
    try {
      return storedUser ? JSON.parse(storedUser) : null;
    } catch (error) {
      console.error("❌ Error al parsear el usuario almacenado:", error);
      localStorage.removeItem("user");
      return null;
    }
  });

  useEffect(() => {
    if (!user) {
      console.warn("🔴 No hay usuario autenticado, redirigiendo a login...");
      navigate("/login", { state: { from: location }, replace: true });
    }
  }, [user, location, navigate]);

  if (!user) {
    return null; // Evita el render antes de la redirección
  }

  return children;
};

const App = () => {
  return (
    <Routes>
      {/* Ruta de Login */}
      <Route path="/login" element={<Login />} />

      {/* Rutas protegidas dentro de Layout */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Home />} />
        <Route path="profesores" element={<Profesores />} />
        <Route path="estudiantes" element={<Estudiantes />} /> {/* Ruta para Estudiantes */}
        <Route path="estudiantes/detalles/:id" element={<EstudianteDetalles />} /> {/* Detalles de estudiante */}
        <Route path="asistencia" element={<Asistencia />} /> {/* Asistencia */}
        <Route path="reportes" element={<Reportes />} /> {/* Reportes */}
        <Route path="faltas/:id" element={<EstudianteFaltas />} /> {/* <-- NUEVA ruta para faltas por estudiante */}
      </Route>

      {/* Redirección si la ruta no existe */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default App;
